import { Injectable } from '@angular/core';

@Injectable()
export class ChartList {
  public name: string;
  public y: number;
  public color: string;
  constructor() {}
}
